export default __webpack_public_path__ + "static/media/e1.1512d193.png";